import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrgRoutingModule } from './org-routing.module';

import { SharedModule } from 'src/app/shared/modules/shared.module';
import { RouterModule } from '@angular/router';
import { OrgDevicesComponent } from './org-devices.component';

@NgModule({
  declarations: [
    OrgDevicesComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    OrgRoutingModule,
    SharedModule
  ]
})
export class OrgModule { }
